import { defineStore } from "pinia";
import { PortalPageUrls } from '@/modules/proportal/types';

export const usePortalPageUrlsStore = defineStore('portalPageUrls', {
    state: () => ({
        portalPageUrls: {} as PortalPageUrls
    })
})